import React from "react";
import { Button } from "../../Button/Button";
function IconButtonCell(_a) {
    var Icon = _a.Icon, text = _a.text, color = _a.color, onClick = _a.onClick;
    return (React.createElement(Button, { LeftIcon: Icon, onClick: onClick, color: color, className: "tw-h-full tw-w-full tw-rounded-none tw-p-0 tw-text-sm tw-font-medium" }, text));
}
export default IconButtonCell;
